import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { MuiCard } from "./components/MuiCard";
import { MuiAlert } from "./components/MuiAlert";

declare module "@mui/material/styles" {
  interface Palette {
    light: Palette["primary"];
  }
  interface PaletteOptions {
    light?: PaletteOptions["primary"];
  }
}

declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    light: true;
  }
}

const lightPaletteColor = {
  main: "#ffffff",
  contrastText: "#000000",
};

export const initTheme = (mode?: "light" | "dark") => {
  const theme = createTheme({
    components: {
      MuiCard,
      MuiAlert,
    },
    palette:
      mode === "dark"
        ? {
            mode,
            primary: {
              // #4C3091
              main: "#7D5DCA",
            },
            secondary: {
              // #843193
              main: "#843193",
            },
            light: lightPaletteColor,
          }
        : {
            mode,
            primary: {
              main: "#3a246f",
            },
            secondary: {
              main: "#411849",
            },
            light: lightPaletteColor,
          },
  });

  return responsiveFontSizes(theme);
};
